export enum WREX_ENHANCED_IMAGE {
    /**
     * @value Apply link
     * @description Label of a button to add a link to an image
     */
    APPLY_LINK = 'WREX_IMAGE.APPLY_LINK',
    /**
     * @value Full width
     * @description Tooltip used on buttons to set an image as full width like an image in the structured content editor
     */
    FULL_WIDTH = 'WREX_IMAGE.FULL_WIDTH',
    /**
     * @value Image
     * @description The label of the submenu option to insert an image. The submenu title will give the context (insert or attach)
     */
    IMAGE_BUTTON_LABEL = 'WREX_IMAGE.BUTTON_LABEL',
    /**
     * @value Insert image
     * @description text editor insert image button tooltip
     */
    INSERT_IMAGE = 'FRONT.TEXT_EDITOR.INSERT_IMAGE',
    /**
     * @value Remove link
     * @description Label used on a button used to remove a link (convert a link text to a normal text)
     */
    REMOVE_LINK = 'COMMUNITY_POST_LINK_REMOVE',
    /**
     * @value Image toolbar
     * @description The label of the wrex image toolbar, this label will only be read by screen readers.
     */
    TOOLBAR = 'WREX_IMAGE.TOOLBAR',
}
